import React, { Suspense } from "react";
import {
  HashRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";

import "./global.css";
import "./i18n";

import AppShell from "./components/AppShell";
import TopBar from "./components/TopBar";
import LegalNotice from "./components/LegalNotice";
import GlobalBanner from "./components/GlobalBanner";

import SignalIntroPage from "./pages/SignalIntroPage";
import SignalBotPage from "./pages/SignalBotPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";

/* ───────── 공통 레이아웃 ───────── */
const Layout: React.FC = () => (
  <>
    <TopBar />
    <Outlet />
    <LegalNotice />
  </>
);

/* ───────── 인트로 게이트 ───────── */
const INTRO_KEY = "intro.seen";
const hasSeenIntro = () => {
  try {
    return localStorage.getItem(INTRO_KEY) === "1";
  } catch {
    return false;
  }
};

const RootGate: React.FC = () => {
  const loc = useLocation();

  // 🔥 ads.txt / app-ads.txt 요청은 절대 라우터가 가로채면 안 됨
  const rawPath = window.location.pathname;

  if (rawPath === "/ads.txt" || rawPath === "/app-ads.txt") {
    return null;
  }

  if (loc.pathname !== "/" || !!loc.search || !!loc.hash) return null;

  return (
    <Navigate to={hasSeenIntro() ? "/signal-bot" : "/signal-intro"} replace />
  );
};

/* ───────── 메인 ───────── */
export default function App() {
  return (
    <HashRouter>
      {/* 🔥 전역 배너는 라우터 바깥, 딱 1번 */}
      <GlobalBanner />

      <AppShell>
        <Suspense fallback={<div style={{ color: "#888", padding: 20 }}>Loading…</div>}>
          <RootGate />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/signal-intro" element={<SignalIntroPage />} />
              <Route path="/signal-bot" element={<SignalBotPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="*" element={<Navigate to="/signal-intro" replace />} />
            </Route>
          </Routes>
        </Suspense>
      </AppShell>
    </HashRouter>
  );
}
